"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSafeEditionMap = void 0;
const config_client_1 = __importDefault(require("./_shared/config.client"));
const config_client_2 = __importDefault(require("./au/config.client"));
const config_client_3 = __importDefault(require("./br/config.client"));
const config_client_4 = __importDefault(require("./ca/config.client"));
const config_client_5 = __importDefault(require("./es/config.client"));
const config_client_6 = __importDefault(require("./fr/config.client"));
const config_client_7 = __importDefault(require("./gr/config.client"));
const config_client_8 = __importDefault(require("./in/config.client")); // `in` is a reserved word
const config_client_9 = __importDefault(require("./it/config.client"));
const config_client_10 = __importDefault(require("./jp/config.client"));
const config_client_11 = __importDefault(require("./kr/config.client"));
const config_client_12 = __importDefault(require("./mg/config.client"));
const config_client_13 = __importDefault(require("./qc/config.client"));
const config_client_14 = __importDefault(require("./spoilsuk/config.client"));
const config_client_15 = __importDefault(require("./uk/config.client"));
const config_client_16 = __importDefault(require("./us/config.client"));
/**
 * A map of all client safe edition config files
 *
 * To add a new edition's config, add it to the map here. You should
 * not need to modify any other processing code.
 *
 * This is only exported for tests and is not intended to be used
 * externally otherwise.
 */
exports.ClientSafeEditionMap = {
    au: config_client_2.default,
    br: config_client_3.default,
    ca: config_client_4.default,
    es: config_client_5.default,
    fr: config_client_6.default,
    gr: config_client_7.default,
    in: config_client_8.default,
    it: config_client_9.default,
    jp: config_client_10.default,
    kr: config_client_11.default,
    mg: config_client_12.default,
    qc: config_client_13.default,
    spoilsuk: config_client_14.default,
    uk: config_client_15.default,
    us: config_client_16.default,
};
const ClientSafeEditions = Object.keys(exports.ClientSafeEditionMap);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isClientSafeEditionId(s) {
    return ClientSafeEditions.includes(s);
}
const ClientSafeConfigByEdition = Object.entries(exports.ClientSafeEditionMap).reduce((accum, [editionId, config]) => {
    const editionConfig = { ...config_client_1.default, ...config };
    return Object.assign(accum, { [editionId]: editionConfig });
}, {}); // eslint-disable-line @typescript-eslint/no-explicit-any
exports.default = {
    isEditionId: isClientSafeEditionId,
    byEdition: ClientSafeConfigByEdition,
};
//# sourceMappingURL=config.client.js.map